import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const SaveClientsRebatesAndReimbursementsDetail = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_CLIENT_REBATES_REIMBURSEMENT_DETAILS, payload, token)
  return res;
};

export const GetClientsRebatesAndReimbursementsDetails = async(clientId, userId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_REBATES_REIMBURSEMENT_DETAILS + `RebatesUserID=${userId}&RebatesClientID=${clientId}`, token)
  return res;
};

export const DeleteClientsRebatesAndReimbursementsDetails = async(id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DETELE_CLIENT_REBATES_REIMBURSEMENT_DETAILS + id, '', token);
  return res;
};
